import { ActionButton } from 'components/button/button.styled'
import { LoadingContainer } from 'components/loadingContainer'
import { PlaceholderContainer } from 'components/placeholder'
import { SeatSelector } from 'components/seatSelector'
import { ShowEventSelector } from 'components/showEventSelector'
import { Container, PageTitle, PageTitleRow, ShowTitle, TitleBox } from 'components/ticket/ticket.style'
import { useEventsAdmin } from 'hooks/admin/useEvents'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { EventDetails } from 'types/Event'

interface Props {
    currentEvent: EventDetails
}

export const LocalSelling = ({ currentEvent }: Props) => {
    const { data: events, isLoading, error } = useEventsAdmin()
    const [isComplimentary, setIsComplimentary] = useState(false)
    const navigate = useNavigate()

    const navigateToRelease = () => {
        navigate(`/admin/jegyek/felszabaditas/${currentEvent.event_id}`)
    }

    const navigateToBasket = (selectedSeats: string[]) => {
        navigate(`/admin/jegyek/kosar/${currentEvent.event_id}?isComplimentary=${isComplimentary}&seats=${selectedSeats.join(',')}`)
    }

    return (
        <Container>
            <PageTitleRow>
                <PageTitle>Kasszás jegyértékesítés</PageTitle>
                <ActionButton onClick={navigateToRelease}>Hely felszabadítás</ActionButton>
            </PageTitleRow>
            <TitleBox>
                <ShowTitle>{currentEvent.show.name}</ShowTitle>
            </TitleBox>
            <LoadingContainer isLoading={isLoading} error={error}>
                {events && (
                    <ShowEventSelector
                        currentEvent={currentEvent}
                        events={events}
                        title="Kiválasztott előadás"
                        redirectUrl="/admin/jegyek/eladas"
                    />
                )}
            </LoadingContainer>
            {currentEvent.location.auditorium ? (
                <SeatSelector
                    currentEvent={currentEvent}
                    actionLabel={'Vásárlás véglegesítése'}
                    actionHandler={navigateToBasket}
                    complimentaryButton={true}
                    isComplimentary={isComplimentary}
                    setIsComplimentary={setIsComplimentary}
                />
            ) : (
                <PlaceholderContainer>
                    <p>A jegyvásárlás jelenleg nem elérhető ehhez az eseményhez.</p>
                </PlaceholderContainer>
            )}
        </Container>
    )
}
